import ProductReview from '../../domains/ProductReview'
import PubSub from '../PubSub'

export interface ReviewPopupState {
  showPopUp: boolean
  productReviews: ProductReview[]
  reviewId: number
  imageIndex: number
}

interface SetReviewPopupPayload {
  productReviews: ProductReview[]
  reviewId: number
  imageIndex: number
}

class ReviewPopupStateManager extends PubSub {
  private state: ReviewPopupState

  constructor() {
    super()
    this.state = { showPopUp: false, productReviews: [], reviewId: 0, imageIndex: 0 }
  }

  showReviewPopUp = (payload: SetReviewPopupPayload) => {
    this.state.showPopUp = true
    this.state.productReviews = payload.productReviews
    this.state.reviewId = payload.reviewId
    this.state.imageIndex = payload.imageIndex
    this.publish()
  }

  hideReviewPopUp = () => {
    this.state.showPopUp = false
    this.state.productReviews = []
    this.state.reviewId = 0
    this.state.imageIndex = 0
    this.publish()
  }

  getReviewPopupState = () => {
    return this.state
  }
}

const reviewPopupStateManager: ReviewPopupStateManager = ReviewPopupStateManager.getInstance('reviewPopupStateManager')

export default reviewPopupStateManager
